const MLMS = new Map();

export default MLMS
